import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './index.module.scss';
import { ReactComponent as Spin } from './ajax-loader-white.svg';

const {
  button,
  byDefault,
  primary,
  white,
  onlyIcon,
  spin,
  red,
  buttonContent,
} = styles;

const Spinner = ({ className }) => (
  <Spin
    height="16"
    width="16"
    alt="Loading"
    className={spin + ' ' + className}
  ></Spin>
);

Spinner.propTypes = {
  className: PropTypes.string.isRequired,
};

const AccionaButton = ({
  onClick,
  msg,
  classIcon,
  className,
  htmlType,
  disabled,
  classIconRight,
  style,
  id,
  type,
  loading,
  tooltip,
}) => {
  const getClassNameByType = () => {
    switch (type) {
      case `primary`:
        return primary;
      case `white`:
        return white;
      default:
        return byDefault;
    }
  };

  return (
    <button
      style={style}
      className={
        className ||
        `${button} ${getClassNameByType()} ${classIcon && !msg ? onlyIcon : ''}`
      }
      onClick={onClick}
      type={htmlType}
      disabled={disabled}
      id={id}
      title={tooltip}
    >
      <div className={buttonContent}>
        {classIcon &&
          (loading ? (
            <Spinner className={type === 'white' ? red : ''} />
          ) : (
            <i className={classIcon} />
          ))}
        {msg}
        {classIconRight &&
          (loading ? (
            <Spinner className={type === 'white' ? red : ''} />
          ) : (
            <i className={classIconRight} />
          ))}
      </div>
    </button>
  );
};

AccionaButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  msg: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  classIcon: PropTypes.string,
  classIconRight: PropTypes.string,
  className: PropTypes.string,
  htmlType: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  type: PropTypes.oneOf(['default', 'primary', 'white']),
  loading: PropTypes.bool,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

AccionaButton.defaultProps = {
  onClick: () => {},
  msg: undefined,
  classIcon: undefined,
  classIconRight: undefined,
  className: '',
  htmlType: 'button',
  disabled: false,
  style: {},
  id: 'AccionaButton',
  type: 'primary',
  loading: false,
  tooltip: undefined,
};

export default AccionaButton;
